<template>
  <div class="create-category">
    <div v-if="selectedCategory" class="create-category__title">Edit Category</div>
    <div v-else class="create-category__title">Create New Category</div>
     <label class="create-category__input">
      <span class="create-category__label">Active</span>
      <div class="create-category__link-wrapper" :class="{'create-category__link-wrapper_single': isDomainDropdownHidden}">
          <base-select
            border-less="true"
            class="create-category__active"
            :disabled="disableButtons"
            :options="activeOpts"
            v-model="category.is_active"
            alignLeft="true"
            :max-height-list="450"
            :titleStyle="titleStyle"
            :headerStyle="selectTypeStyle"
          />
      </div>
    </label>
    <label class="create-category__input">
      <span class="create-category__label">Name</span>
      <div class="create-category__link-wrapper" :class="{'create-category__link-wrapper_single': isDomainDropdownHidden}">
        <input type="text"
               :disabled="disableButtons"
               class="form-control create-category__link-field"
               placeholder="Enter the Name for this category"
               :class="{'form-control_error': externalErrors.name}"
               v-model="category.name">
        <span class="create-category__error-message" v-if="externalErrors.name">{{externalErrors.name}}</span>
      </div>
    </label>
    <label class="create-category__input">
      <span class="create-category__label">Pivot Table</span>
      <div class="create-category__link-wrapper" :class="{'create-category__link-wrapper_single': isDomainDropdownHidden}">
        <input type="text"
               :disabled="disableButtons"
               class="form-control create-category__link-field"
               placeholder="Enter the Pivot Table name"
               :class="{'form-control_error': externalErrors.fk_pivot_table}"
               v-model="category.fk_pivot_table">
        <span class="create-category__error-message" v-if="externalErrors.fk_pivot_table">{{externalErrors.fk_pivot_table}}</span>
      </div>
    </label>
    <label class="create-category__input">
      <span class="create-category__label">Pivot Field</span>
      <div class="create-category__link-wrapper" :class="{'create-category__link-wrapper_single': isDomainDropdownHidden}">
        <input type="text"
               :disabled="disableButtons"
               class="form-control create-category__link-field"
               placeholder="Enter the Pivot Field"
               v-model="category.fk_pivot_field">
      </div>
    </label>
    <label class="create-category__input">
      <span class="create-category__label">Description:</span>
      <div class="form-control description__wrapper" :class="{'description__wrapper_disabled': disableButtons}">
      <textarea
        class="description"
        :disabled="disableButtons"
        rows="6"
        placeholder="Enter Description"
        v-model="category.description"></textarea></div>
    </label>
    <div class="create-category__controls">
      <button class="create-category__button create-category__button_cancel"
              :class="{'create-section__button_disabled': disableButtons}"
              @click.prevent="close()">Cancel
      </button>
      <button v-if="selectedCategory" class="create-category__button create-category__button_delete"
              :class="{'create-section__button_disabled': disableButtons}"
              @click.prevent="openConfirmModal()">
        Delete
      </button>
      <button class="create-category__button create-category__button_submit"
              :class="{'create-section__button_disabled': disableButtons}"
              @click.prevent="apply()">
        Apply
      </button>
    </div>
    <modal name="confirm-modal" v-bind="modalProps">
      <base-confirm-modal title="Are you sure you want to delete this?"
                          subtitle="This Category will be removed permanently!"
                          @confirm="confirmModal" />
    </modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import _ from 'lodash'
import baseModalProps from '@/common/BaseModalProps'
import BaseModalMixins from '@/common/BaseModalMixins'

const SELECT_STYLE = {
  'background-color': 'transparent',
  color: '#284aff',
  'text-decoration': 'underline'
}

const ACTIVE_OPTIONS = [
  {
    label: 'Yes',
    value: 1
  },
  {
    label: 'No',
    value: 0
  }
]
export default {
  name: 'CreateUpdateCategoryPopup',
  mixins: [BaseModalMixins],
  props: {
    selectedCategory: {
      type: Object
    }
  },
  data () {
    return {
      category: _.cloneDeep(this.selectedCategory) || {
        id: -1,
        is_active: 1,
        name: '',
        fk_pivot_table: '',
        fk_pivot_field: '',
        description: ''
      },
      externalErrors: {
        name: null,
        fk_pivot_table: null
      },
      disableButtons: false,
      isValidating: false,
      // should domain name selector be hidden or not
      isDomainDropdownHidden: true,
      elementStyle: {},
      titleStyle: {
        overflow: 'visible'
      },
      activeOpts: _.cloneDeep(ACTIVE_OPTIONS),
      selectTypeStyle: _.cloneDeep(SELECT_STYLE)
    }
  },
  computed: {
    modalProps () {
      return { ...baseModalProps, height: 'auto', width: '510px' }
    }
  },
  methods: {
    ...mapActions('category', ['validate']),
    close () {
      this.$emit('cancel')
    },
    openConfirmModal () {
      this.$modal.show('confirm-modal')
    },
    confirmModal (status) {
      this.$modal.hide('confirm-modal')
      if (status) {
        this.deleteCategory()
      }
    },
    convertToOptions (item) {
      return {
        value: item._id,
        label: item.label
      }
    },
    showErrors (errors) {
      for (const k in this.externalErrors) {
        this.externalErrors[k] = null
      }

      for (const k in errors) {
        this.externalErrors[k] = errors[k]
      }
    },
    deleteCategory () {
      this.$emit('delete', this.category.id)
    },
    async apply () {
      this.disableButtons = true
      const trimFields = ['name', 'fk_pivot_table', 'fk_pivot_field']
      const category = { ...this.category }
      trimFields.forEach(v => {
        category[v] = category[v].trim()
      })
      const response = await this.validate({ category: JSON.stringify({ ...category }) })
      this.disableButtons = false
      if (!Object.keys(response.error_fields).length) {
        this.$emit('apply', category)
      } else {
        this.externalErrors = { ...this.externalErrors, ...response.error_fields }
      }
    }
  }
}
</script>

<style lang="scss">
  .create-category {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 40px;

    &__title {
      text-align: center;
      font-size: 34px;
      font-weight: 500;
      margin: 9px 0 35px;
      color: $rfx-dark-march;
    }

    &__input {
      display: flex;
      flex-direction: column;
      position: relative;
      margin-top: 30px;

      &_invalid[type='text'] {
        border: 1px solid $rfx-red;
        border-radius: 4px;
      }
    }

    &__label {
      display: block;
      font-weight: 600;
      margin-bottom: 5px;
      color: $rfx-dark-march;
    }

    &__controls {
      display: flex;
      justify-content: flex-end;
      margin-top: 30px;
    }
    &__button {
      width: 100px;
      height: 40px;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 900;
      text-transform: uppercase;
      margin-left: 30px;
      border: none;
      outline: none;
      cursor: pointer;

      &_submit {
        background-color: $rfx-medium-march;
        color: #fff;

        &:disabled {
          pointer-events: none;
          background-color: #fff;
          color: $rfx-neutral-grey;
          cursor: default;
        }
      }

      &_disabled {
        pointer-events: none;
        opacity: 0.4;
        cursor: default;
      }

      &_delete {
          background-color: $rfx-red;
          color: #fff
      }

      &_cancel {
        color: $rfx-dark-march;
        background-color: #fff;
      }
    }
    &__link {
      &-wrapper {
        position: relative;
        margin-top: 30px;

        &_single{
          margin-top: 0;
        }
      }

      &-field[type='text'] {
        width: 100%;
        box-sizing: border-box;
        padding-right: 60px;
        font-weight: 500;
        @include ellipsis;
      }
    }

    &__error-message {
        color: $rfx-red;
        font-size: 10px;
        margin-top: 5px;
      }

  }

  .form-control {
    height: 50px;
    padding: 0 20px;
    border: 2px solid $rfx-light-steel;
    outline: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    color: $rfx-dark-march;

    &::placeholder {
      color: $rfx-pearl;
      font-weight: normal;
      font-size: 14px;
    }

    &:disabled {
      background-color: $rfx-light-steel;
    }

    &_error{
       border-color: $rfx-red;
      color: $rfx-red;

       &::placeholder {
         color: $rfx-red;
         font-size: 13px;
       }

     }
  }

  .description {
    width: 100%;
    height: 90%;
    padding: 0;
    resize: none;
    outline: none;
    border: none;
    font-size: 14px;

    &:disabled {
      background-color: transparent;
    }

    &::placeholder {
      color: $rfx-pearl;
      font-weight: normal;
      font-size: 14px;
      margin-top: -5px;
    }

    &__wrapper {
      padding: 10px 20px;
      height: auto;

      &_disabled {
        background-color: #fafafa;
      }
    }
  }

</style>
